<template>
  <div class="pt-3 pb-5" style="min-height: 200px">
    <v-data-table
      :pagination.sync="pagination"
      :loading="loading"
      :headers="headers"
      :items="data"
      class="elevation-1"
    >
      <template #items="props">
        <tr>
          <td class="text-xs-left">{{ props.item.timestamp | dateFormat('DD/MM/YYYY HH:mm') }}</td>
          <td class="text-xs-left">{{ props.item.adminid }}</td>
          <td class="text-xs-left">{{ props.item.function }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import toaCrmApi from '@/api/toa-crm'
import { mapGetters } from 'vuex'

export default {
  props: ['value'],
  data() {
    return {
      headers: [
        { text: 'วันที่', sortable: false, value: 'timestamp' },
        { text: 'ผู้ดำเนินการ', sortable: false, value: 'adminid' },
        { text: 'รายการ', value: 'function', sortable: false }
      ],
      pagination: { sortBy: 'id', descending: true, rowsPerPage: 10 },
      loading: false,
      data: [],
      memberId: this.value
    }
  },
  mounted() {
    this.handleGetEditMemberHistory()
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    async handleGetEditMemberHistory() {
      const vm = this
      try {
        const data = {
          pageId: vm.selectedBot.pageid,
          memberId: vm.memberId
        }

        vm.$store.dispatch('loading')
        const response = await toaCrmApi.getMemberLogs({ config: data })
        vm.$store.dispatch('loading')
        if (response && response.status === 200) {
          vm.data = response.data.data
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/HistoryEditMemberLog.vue